import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";

import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

import theme from "assets/theme";

import themeDark from "assets/theme-dark";

import routes from "routes";

import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";

import ProtectedRoute from "utils/ProtectedRoute";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useAuth } from "utils/AuthContext";
const queryClient = new QueryClient();
export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();
  const location = useLocation();
  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  //   useEffect(() => {
  //   // Don't store /login or auth paths
  //   if (!user && !location.pathname.includes("/authentication/sign-in") && !location.pathname.includes("/logout")) {
  //     console.log("user:",user)
  //     localStorage.setItem("postLoginRedirect", location.pathname);
  //   }
  // }, [user, location]);

  useEffect(() => {
    const isAuthPage =
      location.pathname.includes("/authentication/sign-in") ||
      location.pathname.includes("/logout");

    const params = new URLSearchParams(location.search);
    const isRedirect = params.get("redirect") === "true";

    if (!user && !isAuthPage && isRedirect && !localStorage.getItem("postLoginRedirect")) {
      console.log("📌 Saving postLoginRedirect:", location.pathname + location.search);
      localStorage.setItem("postLoginRedirect", location.pathname + location.search);
    }
  }, [location, user]);

  const getRoutes = (allRoutes) =>
    allRoutes.flatMap((route) => {
      const generatedRoutes = [];

      if (route.route && route.component) {
        let element = route.component;

        // Wrap in ProtectedRoute if it's a protected route
        if (route.protected) {
          element = (
            <ProtectedRoute allowedRoles={route.role}>
              {route.component}
            </ProtectedRoute>
          );
        }
        generatedRoutes.push(<Route exact path={route.route} element={element} key={route.key} />);
      }

      if (route.collapse) {
        generatedRoutes.push(...getRoutes(route.collapse));
      }

      return generatedRoutes;
    });

  return (
    <>
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            {/* <Configurator /> */}
            {/* {configsButton} */}
          </>
        )}
        {/* {layout === "vr" && <Configurator />} */}
        <QueryClientProvider client={queryClient}>
          <Routes>
            {getRoutes(routes)}
            <Route
              path="*"
              element={
                user ? (
                  <Navigate to={user.role_id === 3 ? "/user-dashboard" : "/dashboard"} />
                ) : (
                  <Navigate to="/authentication/sign-in" />
                )
              }
            />
          </Routes>
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
}
